import React from 'react'
import arrowLeft from "../images/arrow-left.svg"
import arrowRight from "../images/arrow-right.svg"
import styled from "styled-components"

const Button = styled.div`
    position: absolute;
    display: inline-block;
    left: ${({left}) => left && '-80px'};
    right: ${({left}) => !left && '-80px'};
    transform: translate(0, -30px);
    top: 50%;
    width: ${({width}) => width + "px"};
    height: ${({height}) => height + "px" };
    background-image: ${({left}) => left ? `url(${arrowLeft})` : `url(${arrowRight})` };
    :hover{
        transform: ${({left}) => left ? `translate(4px, -27px)` : `translate(-4px, -24px)` };
    }
    @media( max-width: 1000px){
        left: ${({left}) => left && '-40px'};
        right: ${({left}) => !left && '-40px'};
        width: 40px;
        height: 40px;
    }
`

export default function Arrow(props) {
    const {onClick} = props
    return (
        <Button  
            left={props.left}
            onClick={onClick}
            width={props.width} 
            height={props.height}
        />
    )
}
